import Fuse from 'fuse.js'


export const movieSearchOptions = {
    includeScore: false,
    useExtendedSearch: true,
    fieldNormWeight: 2,
    threshold: 0.2,
    fieldLengthNorm: 100,
    distance: 1000
,
    keys: [
        {
            name: 'title',
            weight: 1
        },
        {
            name: 'titleDisplay',
            weight: 1
        },
        {
            name: 'origTitle',
            weight: 0.5
        },
        {
            name: 'subTitle',
            weight: 0.5
        },
        {
            name: 'directors.name',
            weight: 0.3
        },
        {
            name: 'actors.character',
            weight: 0.4
        },
        {
            name: 'actors.name',
            weight: 0.4
        },
        {
            name: 'genres',
            weight: 0.3
        }
    ]
        
}


const getItemsBySearch = (movieItems, searchValues) => {
    if(!movieItems || !searchValues || !searchValues[0]) {
        return []
    }

    const searchString = searchValues.join(" ")

    if(!searchString) {
        return []
    }

    const fuse = new Fuse(Object.values(movieItems), movieSearchOptions)

    return fuse.search(searchString).flatMap(item => item.item.pk)
}

export default getItemsBySearch